import React, { useEffect } from 'react';
import ModalHeader from '../molecules/ModalHeader';
import ModalFooter from '../molecules/ModalFooter';
import RadioGroup from '../atoms/RadioGroup';
import FormInput from '../atoms/FormInput';

/**
 * Step5HotelTransfer - Paso 5: Traslado al hotel
 *
 * Props:
 * - maxPersons: Número máximo de personas
 * - hotelTransfer: Objeto { needsTransfer, numberOfTickets }
 * - onChange: Función callback (fieldName, value) => void para hotelTransfer
 * - errors: Objeto con errores { hotelTransfer: { needsTransfer, numberOfTickets } }
 * - onBack: Función callback para volver
 * - onContinue: Función callback para continuar
 * - isLoading: Boolean indicando si está procesando
 * - className: Clases CSS adicionales (opcional)
 */
function Step5HotelTransfer({
  maxPersons,
  hotelTransfer = { needsTransfer: 'SI', numberOfTickets: '' },
  onChange,
  errors = {},
  onBack,
  onContinue,
  isLoading = false,
  className = ''
}) {
  // Auto-set numberOfTickets to maxPersons on mount or when maxPersons changes
  useEffect(() => {
    if (hotelTransfer.numberOfTickets !== maxPersons.toString()) {
      onChange('numberOfTickets', maxPersons.toString());
    }
  }, [maxPersons, hotelTransfer.numberOfTickets, onChange]);

  const handleFieldChange = (fieldName) => (value) => {
    onChange(fieldName, value);
  };

  const transferOptions = [
    { value: 'SI', label: 'Sí' },
    { value: 'NO', label: 'No' }
  ];

  return (
    <div className={`d-flex flex-column gap-4 rounded mx-auto ${className}`}>
      <ModalHeader
        title="Completa tu Información"
        subtitle="Traslado al Hotel"
        currentStep={4}
      />

      <div className="bg-white rounded px-2">
        <RadioGroup
          label="¿Necesita traslado al hotel?"
          options={transferOptions}
          value={hotelTransfer.needsTransfer}
          onChange={handleFieldChange('needsTransfer')}
          error={errors.hotelTransfer?.needsTransfer}
          required
        />

        {/* N. Pasajes */}
        <FormInput
          label="Número de Pasajes"
          placeholder="0"
          value={hotelTransfer.numberOfTickets}
          onChange={(e) => handleFieldChange('numberOfTickets')(e.target.value)}
          error={errors.hotelTransfer?.numberOfTickets}
        />
      </div>

      <ModalFooter
        onBack={onBack}
        onContinue={onContinue}
        continueText="Finalizar Reserva"
        backText="Atrás"
        isLoading={isLoading}
        isSubmit={true}
      />
    </div>
  );
}

export default Step5HotelTransfer;
